import React from 'react'

import styles from './GenericDataRow.module.scss'

export const GenericDataRowContent = ({children, contentColour, extraStyle}) => {
  return (
    <div className={styles['data-row-field']} style={{backgroundColor: contentColour || undefined, ...extraStyle}}>
      {children}
    </div>
  )
}

export const GenericDataRowTitle = ({title}) => {
  return (
    <div className={styles['data-row-title']}>{title}</div>
  )
}

export default function GenericDataRow({
  title,
  children,
  contentColour,
  style = {},
  contentStyle = {}
}) {
  return (
    <div className={styles.container} style={style}>
      <div className={styles['data-row-title']}>{title}</div>
      <GenericDataRowContent contentColour={contentColour} extraStyle={contentStyle}>
        {children}
      </GenericDataRowContent>
    </div>
  )
}
